import React from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
const GenderAgeBarChart = ({ genderAgeStatistics, width, height }) => {
  const { t } = useTranslation();
  const data = {
    labels: genderAgeStatistics?.ageRanges || ['18-25', '25-35', '35-45', '45+'],
    datasets: [
      {
        label: t("Male"),
        data: genderAgeStatistics?.maleData || [0, 0, 0, 0],
        borderColor: "#3b4cb8",
        borderWidth: 0,
        backgroundColor: "#3b4cb8",
      },
      {
        label: t("Female"),
        data: genderAgeStatistics?.femaleData || [0, 0, 0, 0],
        borderColor: "rgba(89, 59, 219, 0.7)",
        borderWidth: 0,
        backgroundColor: "rgba(89, 59, 219, 0.7)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'top',
      labels: {
        fontColor: "#999",
        fontSize: 14,
        padding: 15
      }
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            color: "rgba(89, 59, 219, 0.1)",
            drawBorder: true,
          },
          ticks: {
            fontColor: "#999",
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: t('Number of Donors'),
            fontColor: "#666",
            fontSize: 12
          }
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
            zeroLineColor: "transparent",
          },
          ticks: {
            fontColor: "#999",
            fontFamily: "Nunito, sans-serif",
          },
          scaleLabel: {
            display: true,
            labelString: t("Age Range"),
            fontColor: "#666",
            fontSize: 12
          }
        },
      ],
    },
    tooltips: {
      mode: "index",
      intersect: false,
      titleFontColor: "#888",
      bodyFontColor: "#555",
      titleFontSize: 12,
      bodyFontSize: 15,
      backgroundColor: "rgba(256, 256, 256, 0.95)",
      displayColors: true,
      xPadding: 10,
      yPadding: 7,
      borderColor: "rgba(220, 220, 220, 0.9)",
      borderWidth: 2,
      caretSize: 6,
      caretPadding: 10,
    },
  };
  return (
    <div style={{ minHeight: "290px" }}>
      <Bar
        data={data}
        width={width ? width : 433}
        height={height ? height : 251}
        options={options}
      />
    </div>
  );
};

export default GenderAgeBarChart;